import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMoon,
  faSun,
  faCode,
  faUser,
  faProjectDiagram,
  faStar,
  faExternalLinkAlt,
  faGuitar,
  faGlobeAmericas,
  faBook,
  faBiking,
  faCoffee,
} from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faLinkedinIn,
  faTwitter,
  faCodepen,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faMoon,
  faSun,
  faCode,
  faUser,
  faProjectDiagram,
  faStar,
  faExternalLinkAlt,
  faGuitar,
  faGlobeAmericas,
  faBook,
  faBiking,
  faCoffee,
  faGithub,
  faLinkedinIn,
  faTwitter,
  faCodepen
);
